<template>
  <div style="padding-top: 25px;">
    <b-loading :is-full-page="false" v-model="loading" :can-cancel="false">
      <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin">
      </b-icon>
    </b-loading>
    <div class="columns is-centered ubuntu">
      <div class="column is-10">
        <section class="container boxWithBorder">
          <div class="box  is-light" v-if="user">
            <div class="mb-5">
              <router-link
                to="/admin/users"
                class="has-text-primary has-text-weight-bold is-size-4"
                >Users</router-link
              >
              >
              <span class="has-text-primary has-text-weight-light is-size-4"
                >{{ user.fullName }}
                <b-tag v-if="user.fullName"
                  :type="
                    user.contactStatus === 'Active' ? 'is-success' : 'is-danger'
                  "
                  size="is-medium"
                >
                  {{ user.contactStatus }}
                </b-tag>
              </span>
            </div>

            <br />

            <b-tabs @input="checkForUnsavedData()">
              <b-tab-item
                label="Personal Information"
                icon="card-account-details"
              >
                <div class="box profile">
                  <div class="has-text-centered is-centered">
                    <b-icon :icon="icon" size="is-large" type="is-primary">
                    </b-icon>
                    <p class="title is-5" style="">
                      Personal Information
                    </p>
                  </div>
                  <b-loading
                    :is-full-page="false"
                    v-model="loading"
                    :can-cancel="false"
                  >
                    <b-icon
                      icon="autorenew"
                      size="is-large"
                      custom-class="mdi-spin"
                    >
                    </b-icon>
                  </b-loading>

                  <br />
                  <br />
                  <div class="columns is-mobile">
                    <div class="column sect">
                      <div class="columns">
                        <div class="column is-half">
                          <section>
                            <b-field label="First Name">
                              <b-input
                                v-model="user.firstName"
                                disabled
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Last Name">
                              <b-input
                                v-model="user.lastName"
                                disabled
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-half">
                          <section>
                            <b-field label="Date of Birth">
                              <b-input
                                @change.native="
                                  handleChange(
                                    'dateOfBirth',
                                    $event.target.value
                                  )
                                "
                                v-model="user.dateOfBirth"
                                placeholder="mm/dd/yyyy"
                                v-cleave="masks.dob"
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Gender">
                              <b-select
                                @change.native="
                                  handleChange('gender', $event.target.value)
                                "
                                v-model="user.gender"
                                placeholder="Select Gender"
                                expanded
                              >
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="X">Non-Binary</option>
                              </b-select>
                            </b-field>
                          </section>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-half">
                          <section>
                            <b-field label="Mobile Phone">
                              <b-input
                                @change.native="
                                  handleChange(
                                    'mobilePhone',
                                    $event.target.value
                                  )
                                "
                                v-model="user.mobilePhone"
                                v-cleave="masks.phone"
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Email">
                              <b-input
                                v-model="user.email"
                                required
                                type="email"
                                disabled
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-half">
                          <!-- <section>
                            <b-field label="Contact Status">
                              <b-select
                                v-model="user.contactStatus"
                                @change.native="
                                  handleChange(
                                    'contactStatus',
                                    $event.target.value
                                  )
                                "
                                expanded
                              >
                                <option value="Active">Active</option>
                                <option value="In-Active">In-Active</option>
                              </b-select>
                            </b-field>
                          </section>-->
                          <section>
                            <b-field label="Contact Status">
                              <template #label>
                                Contact Status
                                <b-tooltip type="is-dark">
                                  <b-icon
                                    size="is-small"
                                    icon="help-circle-outline"
                                  ></b-icon>

                                  <template v-slot:content>
                                    To activate or deactivate a contact, click
                                    the toggle button and save changes
                                  </template>
                                </b-tooltip>
                              </template>

                              {{ user.contactStatus }}
                              <b-switch
                                v-model="user.contactStatus"
                                true-value="Active"
                                false-value="In-Active"
                                @change.native="
                                  handleChange(
                                    'contactStatus',
                                    user.contactStatus
                                  )
                                "
                              ></b-switch>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Travel Manager">
                              <b-taginput
                                validation-message="Enter  travel manager's email address"
                                @add="addTravelerManager"
                                @remove="removeTravelerManager"
                                ref="taginput"
                                v-model="user.travelArrangers"
                                :data="company_contacts"
                                autocomplete
                                :allow-new="false"
                                :open-on-focus="false"
                                field="email"
                                icon="email"
                                maxtags="1"
                                :has-counter="false"
                                type="is-primary"
                                placeholder="Enter travel manager's email address"
                                @typing="getFilteredContacts"
                              >
                                <template v-slot="props">
                                  <strong>{{ props.option.name }}</strong
                                  >: {{ props.option.email }}
                                </template>
                                <template #empty>
                                  Contact not found
                                </template>
                                <template #selected="props">
                                  <b-tag
                                    v-for="(tag, index) in props.tags"
                                    :key="index"
                                    :tabstop="false"
                                    closable
                                    size="is-medium"
                                    @close="
                                      $refs.taginput.removeTag(index, $event)
                                    "
                                  >
                                    {{ tag.name }}
                                  </b-tag>
                                </template>
                              </b-taginput>
                            </b-field>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    expanded
                    @click="updateUser()"
                  >
                    Save Changes
                  </b-button>
                  <br />
                </div>
              </b-tab-item>
              <b-tab-item
                label="Emergency Contacts"
                icon="shield-account"
                v-if="user.emergencyContact"
              >
                <div class="box profile">
                  <div class="columns is-mobile">
                    <div class="column sect">
                      <div class="columns">
                        <div class="column is-half">
                          <section>
                            <b-field label="Emergency Contact Name">
                              <b-input
                                v-model="user.emergencyContact.name"
                                @change.native="
                                  handleChange(
                                    'emergencyContactName',
                                    $event.target.value
                                  )
                                "
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Relationship">
                              <b-select
                                v-model="user.emergencyContact.relationship"
                                @change.native="
                                  handleChange(
                                    'emergencyContactRelationship',
                                    $event.target.value
                                  )
                                "
                                placeholder="Select Relationship"
                                expanded
                              >
                                <option value="Other">Other</option>
                                <option value="Brother">Brother</option>
                                <option value="Friend">Friend</option>
                                <option value="LifePartner"
                                  >Life Partner</option
                                >
                                <option value="Parent">Parent</option>
                                <option value="Partner">Partner</option>
                                <option value="Sister">Sister</option>
                                <option value="Spouse">Spouse</option>
                              </b-select>
                            </b-field>
                          </section>
                        </div>
                      </div>

                      <div class="columns">
                        <div class="column is-half">
                          <section>
                            <b-field label="Mobile Phone">
                              <b-input
                                v-model="user.emergencyContact.phone"
                                @change.native="
                                  handleChange(
                                    'emergencyContactPhone',
                                    $event.target.value
                                  )
                                "
                                v-cleave="masks.phone"
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                        <div class="column is-half">
                          <section>
                            <b-field label="Email">
                              <b-input
                                v-model="user.emergencyContact.email"
                                @change.native="
                                  handleChange(
                                    'emergencyContactEmail',
                                    $event.target.value
                                  )
                                "
                                type="email"
                              ></b-input>
                            </b-field>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-button
                    class="is-pulled-right"
                    type="is-primary"
                    expanded
                    @click="updateUser()"
                  >
                    Save Changes
                  </b-button>
              
                </div>
              </b-tab-item>

              <b-tab-item label="Travel Programs" v-if="user.travelerPrograms">
                <template #header>
                  <b-icon icon="train-car"></b-icon>
                  <span>
                    Travel Programs
                    <b-tag type="is-success">{{
                      user.travelerPrograms.length
                    }}</b-tag></span
                  >
                </template>
                <div class="box profile">
                  <span>
                    <b-button
                      size="is-small"
                      type="is-link"
                      class="is-pulled-right is-primary"
                      icon-left="plus"
                      @click="uploadTravelerProgramModal('Add')"
                    >
                      Add Traveler Program
                    </b-button>
                  </span>
                  <br />
                  <b-table
                    :data="user.travelerPrograms"
                    default-sort="type"
                    :bordered="false"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    :mobile-cards="true"
                  >
                    <b-table-column
                      field="type"
                      label="Type"
                      v-slot="props"
                      sortable
                    >
                      <span class="">
                        <b-icon
                          v-if="props.row.type == 'Car'"
                          icon="car"
                        ></b-icon>
                        <b-icon
                          v-if="props.row.type == 'Hotel'"
                          icon="bed"
                        ></b-icon>
                        <b-icon
                          v-if="props.row.type == 'Air'"
                          icon="airplane"
                        ></b-icon> </span
                      >&nbsp;
                      <span> {{ props.row.type }} </span>
                    </b-table-column>

                    <b-table-column
                      field="name"
                      label="Vendor Name"
                      v-slot="props"
                      sortable
                    >
                      {{ props.row.name }}
                    </b-table-column>

                    <b-table-column
                      field="accountNumber"
                      label="Program No"
                      v-slot="props"
                    >
                      {{ props.row.accountNumber }}
                    </b-table-column>

                    <b-table-column v-slot="props">
                      <span style="margin-right: 15px">
                        <a
                          @click="uploadTravelerProgramModal('Edit', props.row)"
                        >
                          <b-icon icon="pencil" size="is-small"></b-icon
                        ></a>
                      </span>
                      <span>
                        <a @click="deleteTravelerProgram(props.row.id)">
                          <b-icon icon="delete" size="is-small"></b-icon
                        ></a>
                      </span>
                    </b-table-column>

                    <template #empty>
                      <div class="has-text-centered">
                        No travel programs found
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-tab-item>

              <b-tab-item label="Unused Tickets" v-if="user.unusedTickets">
                <template #header>
                  <b-icon icon="ticket"></b-icon>
                  <span>
                    Unused Tickets
                    <b-tag type="is-success">{{
                      user.unusedTickets.length
                    }}</b-tag></span
                  >
                </template>

                <div class="box profile">
                  <b-table
                    :data="user.unusedTickets"
                    ref="table"
                    detail-key="id"
                    :bordered="false"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    :mobile-cards="true"
                  >
                    <b-table-column field="ticketNumber" label="Ticket Number">
                      <template v-slot="props">
                        {{ props.row.ticketNumber }}
                      </template>
                    </b-table-column>

                    <b-table-column field="airline" label="Airline" sortable>
                      <template v-slot="props">
                        {{ props.row.airline }}
                      </template>
                    </b-table-column>
                    <b-table-column
                      field="firstName"
                      label="Original Ticket Owner"
                      sortable
                    >
                      <template v-slot="props">
                        {{ props.row.firstName }} {{ props.row.lastName }}
                      </template>
                    </b-table-column>

                    <b-table-column field="status" label="Status" sortable>
                      <template v-slot="props">
                        <span
                          :class="[
                            'tag',
                            { 'is-success': (props.row.status = 'Open') },
                            { 'is-warning': props.row.status == 'In-Process' },
                          ]"
                        >
                          {{ props.row.status }}
                        </span>
                      </template>
                    </b-table-column>

                    <b-table-column
                      field="amount"
                      label="Total Air Fare"
                      sortable
                    >
                      <template v-slot="props">
                        ${{ props.row.amount }}
                      </template>
                    </b-table-column>

                    <b-table-column
                      field="expirationDate"
                      label="Expiration Date"
                      sortable
                    >
                      <template v-slot="props">
                        {{ props.row.expirationDate }}
                      </template>
                    </b-table-column>

                    <b-table-column field="type" label="Type" sortable>
                      <template v-slot="props">
                        {{ props.row.type }}
                      </template>
                    </b-table-column>

                    <template #empty>
                      <div class="has-text-centered">No tickets found</div>
                    </template>
                  </b-table>
                </div>
              </b-tab-item>
            </b-tabs>

            <br />
            <br />
          </div>

          <div v-else>Cannot fetch User</div>
        </section>
      </div>
    </div>
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
  </div>
</template>
<script>
import Cleave from "cleave.js";
import AddTravelerProgramModalVue from "../components/MyUsers/AddTravelerProgramModal.vue";
var moment = require("moment"); // require

const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};

export default {
  name: "UserProfilePage",
  directives: { cleave },

  components: {},
  props: {
    id: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      user: [],
      user_modified: [],
      travelManager: [],
      company_contacts: this.contacts,
      loading: true,
      icon: "alpha-i-circle",

      masks: {
        creditCard: { creditCard: true },
        numeral: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "$ ",
        },
        date: {
          date: true,
          datePattern: ["m", "y"],
        },
        dob: {
          date: true,
          delimiter: "/",
          datePattern: ["m", "d", "Y"],
        },
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
      },
    };
  },
  methods: {
    checkForUnsavedData() {
      if (this.user_modified.length > 0) {
        this.confirmAutoSave();
      }
    },

    confirmAutoSave() {
      this.$buefy.dialog.confirm({
        message:
          "You have unsaved changes in the previous tab. Do you want to save them?",
        cancelText: "No",
        confirmText: "Yes",
        onConfirm: () => this.updateUser(),
        onCancel: () => (this.user_modified = []),
      });
    },

    updateUser() {
      if (this.user_modified.length === 0) {
        this.$buefy.dialog.alert({
          title: "Saving Changes",
          message: "You have not made any changes to save",
          type: "is-info",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
        return;
      } else {
        this.loading = true;

        var body = {
          contactId: this.profile.id,
          userId: this.user.id,
          userData: this.user_modified,
        };

        this.$app
          .huddleLabsServerCall("profile/contact/update", body)
          .then((result) => {
            if (!result.error) {
              if (!result.success) {
                this.$buefy.toast.open({
                  message: "An error occured updating your information.",
                  type: "is-danger",
                });

                this.loading = false;
              } else {
                this.loading = false;
                this.$buefy.toast.open({
                  message: "Profile changes saved",
                  type: "is-success",
                });
                this.user_modified = [];

                this.getUser();
                return true;
              }
            }
          })
          .catch((error) => {
            this.loading = false;

            this.$buefy.toast.open({
              message: "An error occured updating your information.",
              type: "is-danger",
            });

            console.log(error);
          });
      }
    },
    handleChange(changedField, changedValue) {
      const results = this.user_modified.filter(
        (field) => field.name !== changedField
      );

      var temp = { name: null, value: null };

      temp.name = changedField;

      temp.value = changedValue;

      if (changedField == "dateOfBirth")
        temp.value = moment(changedValue, "MM-DD-YYYY").format("YYYY-MM-DD");

      results.push(temp);

      this.user_modified = results;
    },

    addTravelerManager() {
      const results = this.user_modified.filter(
        (field) => field.name != "addTravelManager"
      );

      var temp = { name: null, value: null };

      temp.name = "addTravelManager";

      temp.value =
        this.user.travelArrangers.length != 0
          ? this.user.travelArrangers[0].id
          : null;

      results.push(temp);

      this.user_modified = results;
    },

    removeTravelerManager() {
      const results = this.user_modified.filter(
        (field) => field.name != "removeTravelManager"
      );

      var temp = { name: null, value: null };

      temp.name = "removeTravelManager";

      temp.value =
        this.travelManager.length != 0 ? this.travelManager[0].recordId : null;

      results.push(temp);

      this.user_modified = results;
    },
    uploadTravelerProgramModal(mode = "New", program = null) {
      var details = {
        parent: this,
        component: AddTravelerProgramModalVue,
        props: {
          user: this.user,
          travelerprogram: program
            ? program
            : {
                id: null,
                type: "",
                accountNumber: "",
                traveler_program: "",
              },
          mode: mode,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          "upload-success": () => {
            this.getUser();
          },
        },
      };
      this.$buefy.modal.open(details);
    },

    deleteTravelerProgram(id) {
      this.$buefy.dialog.confirm({
        title: "Deleting traveler program",
        message:
          "Are you sure you want to <b>delete</b> this traveler program?",
        confirmText: "Yes",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;

          var body = {
            contactId: this.profile.id,
            userId: this.user.id,
            travelerProgramId: id,
          };

          this.$app
            .huddleLabsServerCall("profile/traveler-programs/deactivate", body)
            .then((result) => {
              if (!result.error) {
                if (!result.success) {
                  this.$buefy.toast.open({
                    message: "An error occured deleting Traveler Program.",
                    type: "is-danger",
                  });

                  this.loading = false;
                } else {
                  this.loading = false;
                  this.$buefy.toast.open({
                    message: "Traveler Program successfully deleted",
                    type: "is-success",
                  });
                  this.getUser();
                  return true;
                }
              }
            })
            .catch((error) => {
              this.loading = false;

              this.$buefy.toast.open({
                message: "An error occured deleting Traveler Program.",
                type: "is-danger",
              });

              console.log(error);
            });
        },
      });
    },
    getFilteredContacts(text) {
      this.company_contacts = this.contacts.filter((option) => {
        return (
          option.email.indexOf(text.toString().toLowerCase()) >= 0 ||
          option.name.indexOf(text.toString().toLowerCase()) >= 0
        );
      });
    },
    dobFormatted(date) {
      if (date) return moment(date).format("MM/DD/YYYY");
    },

    getUser() {
      console.log("Running get user");
      this.loading = true;
      var body = { contactId: this.profile.id, userId: this.id };
      this.$app
        .huddleLabsServerCall("profile/contact/show", body)
        .then((result) => {
          if (!result.error) {
            console.log(result.data);
            this.user = result.data;
            this.user.dateOfBirth = this.dobFormatted(this.user.dateOfBirth);
            this.travelManager = result.data.travelArrangers;
            this.icon =
              "alpha-" + this.user.firstName[0].toLowerCase() + "-circle";

            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$buefy.toast.open({
            message: "Error fetching user information.",
            type: "is-danger",
          });
        });

      return this.user;
    },

    async TravelProfileFields() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + this.$store.state.app.token
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        "https://www.gantgateway.com/api/travel-profile/fields",
        requestOptions
      )
        .then((result) => {
          this.$store.commit(
            "userManagement/ADD_PROFILE_FIELDS",
            JSON.parse(result)
          );
        })
        .catch((error) => console.log("error", error));
    },
    async vendorProgramsFields() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer " + this.$store.state.app.token
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        "https://www.gantgateway.com/api/vendors/car?only_popular=1",
        requestOptions
      )
        .then((result) => result.text())
        .then((result) => {
          this.$store.commit(
            "userManagement/ADD_CAR_VENDOR_FIELDS",
            JSON.parse(result)
          );
        })

        .catch((error) => console.log("error", error));

      await fetch(
        "https://www.gantgateway.com/api/vendors/air?only_popular=1",
        requestOptions
      )
        .then((result) => result.text())
        .then((result) => {
          this.$store.commit(
            "userManagement/ADD_AIR_VENDOR_FIELDS",
            JSON.parse(result)
          );
        })
        .catch((error) => console.log("error", error));

      await fetch(
        "https://www.gantgateway.com/api/vendors/hotel?only_popular=1",
        requestOptions
      )
        .then((result) => result.text())
        .then((result) => {
          this.$store.commit(
            "userManagement/ADD_HOTEL_VENDOR_FIELDS",
            JSON.parse(result)
          );
        })
        .catch((error) => console.log("error", error));
    },
  },
  mounted() {
    //this.TravelProfileFields();
    this.getUser();
    this.vendorProgramsFields();
  },
  computed: {
    profile() {
      return this.$globals.profile;
    },
    contacts() {
      return this.$store.getters["userManagement/getCompanyContacts"];
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.user_modified.length > 0) {
      this.$buefy.dialog.confirm({
        title: "Unsaved changes",
        message:
          "You have unsaved changes. If you leave, your changes will be lost. Are you sure you want to proceed?",
        confirmText: "Yes",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => next(),
        onCancel: () => next(false),
      });
    } else {
      next();
    }
  },
};
</script>

<style scoped></style>
